import { makeStyles, colors } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "relative",
      overflow: "hidden",
      height: "100%",
      background: theme.palette.common.white,

      "& .tabPanel": {
        position: "relative",
        overflow: "hidden",
        marginTop: 100,
        borderTop: "1px solid #e8e8e8",
      },
    },

    paperTobTabs: {
      position: "fixed",
      top: 52,
      left: 0,
      right: 0,
    },

    loaderWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2000,

      height: "100%",
    },

    loaderOverlay: {
      height: "100%",
      backgroundColor: theme.palette.common.white,
      opacity: 0.2,
    },

    errorWrapper: {
      position: "fixed",
      top: 50,
      left: 0,
      right: 0,
      zIndex: 3000,
    },

    errorWrapperContent: {
      backgroundColor: colors.red[400],
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium,
      paddingTop: 15,
      paddingBottom: 15,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),

      "& .content": {},

      "& .action": {
        display: "inline-block",
        cursor: "pointer",
        textTransform: "uppercase",
      },
    },
  }),
  { name: "icip-admin-styles", flip: null }
);

export default useStyles;
